// import * as Minio from "minio";
// import S3 from "aws-sdk/clients/s3";
import AWS from "aws-sdk";
import * as Sentry from "@sentry/vue";
import { toNumber } from "lodash";
import { BaseApiService } from "../api-base";
import ConfigAWS from "./config-aws.json";

export class MinioApiService extends BaseApiService {
  get url() {
    return this.settings.services.minio.url_api;
  }

  s: any;
  endPoint: any;
  port!: number;
  s3Client!: AWS.S3;
  bucket = "images";

  constructor() {
    super("minio");
    if (this.url) {
      const { s, endPoint, port } = this.url.match(
        /(http(?<s>s)?:\/\/)?(?<endPoint>[^:]+)(:(?<port>\d+))?/
      ).groups;

      this.s = s;
      this.endPoint = endPoint;
      this.port = toNumber(port);
    }
  }

  initS3Client() {
    if (!this.s3Client) {
      try {
        const endpoint =
          (!!this.s ? "https" : "http") +
          "://" +
          this.endPoint +
          (this.port ? `:${this.port}` : "");
        if (
          ConfigAWS?.credentials?.accessKeyId &&
          ConfigAWS?.credentials?.secretAccessKey
        ) {
          AWS.config.update(ConfigAWS);
        } else {
          AWS.config.credentials = new AWS.Credentials("", "");
        }
        this.s3Client = new AWS.S3({
          s3BucketEndpoint: true,
          endpoint,
        });
        // console.log("endpoint", endpoint);
      } catch (error) {
        console.log("Minio error", error);
        Sentry.captureException(error);
      }
    }
  }

  putObject(bucket: string, pathname: string, blob: Blob) {
    this.initS3Client();
    bucket = bucket || this.bucket;
    return new Promise((resolve, reject) => {
      this.s3Client.putObject(
        {
          Bucket: bucket,
          Key: bucket + "/" + pathname,
          Body: blob,
        },
        (err, data) => {
          if (err) reject(err);
          else resolve(data);
        }
      );
    });
  }

  async putImage(file: any) {
    // console.log("putImage file", file);
    this.initS3Client();
    const buf = await (await fetch(file.url)).blob();
    return new Promise((resolve, reject) => {
      this.s3Client.putObject(
        {
          Bucket: this.bucket,
          Key: this.bucket + "/" + file.filename,
          Body: buf,
          ContentType: file.type,
          Metadata: {
            "Content-Type": file.type,
          },
        },
        (err, etag) => {
          if (err) return reject(err);
          console.log("Image uploaded successfully.", this.getPath(file));
          file.path = this.getPath(file);
          file.meta = {
            url: this.url,
            endPoint: this.endPoint,
            bucket: this.bucket,
            port: this.port,
          };
          resolve(file);
        }
      );
    });
  }

  getPath(file: any) {
    return `${this.url}/${this.bucket}/${file.filename}`;
  }
}
